import ReportFilters from './ReportFilters';
export default ReportFilters;



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/components/ReportHeader/components/ReportFilters/index.js